import { QRParentChildData } from "../Constants/QRParentChild"

export const getQrParentChildData = (qrDetails) => {
    return {
        type: QRParentChildData.GET_QRParentChildData,
        payload: qrDetails
    };
};